import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { RecommendedHomeRow } from '@sales-app/hooks/useFavoritesPinnedHomes/useFavoritesPinnedHomes.util'
import { AvailableHome } from '@sales-app/types/Home'

import { getPricingFields } from '../../RecommendedHomes.data'

export function getHomesTabs(homes: Array<RecommendedHomeRow>) {
  const bedroomTypes: Array<number> = []

  const bedroomObj = homes.reduce(
    function (acc, home) {
      if (!acc[home.bedrooms]) {
        bedroomTypes.push(home.bedrooms)
        acc[home.bedrooms] = []
      }

      acc[home.bedrooms].push(home)
      return acc
    },
    Object.create({
      bedrooms: [],
    }),
  )

  bedroomTypes.sort()

  function getBedroomTitle(bedroom: number, index: number) {
    const bedroomTypeCopy = bedroom > 1 ? bedroom + ' Beds' : bedroom + ' Bed'
    if (bedroomTypes.length <= 3) {
      return bedroomTypeCopy
    }
    if (bedroomTypes.length > 3) {
      const title = bedroomTypes[2] + '+ Beds'
      if (index < 2) {
        return bedroomTypeCopy
      } else {
        return title
      }
    }
  }

  const homeDataObj = bedroomTypes.map((bedroom, index) => {
    return {
      title: bedroom == 0 ? 'Studio' : getBedroomTitle(bedroom, index),
      data: bedroomObj[bedroom] || [],
    }
  })

  function getMergeHomeData() {
    let mergedHomeData: any = []

    for (let i = 0; i < homeDataObj.length; i++) {
      if (i <= 2) {
        mergedHomeData.push(homeDataObj[i])
      } else {
        mergedHomeData[2].data = [...mergedHomeData[2].data, ...homeDataObj[i].data]
      }
    }

    return mergedHomeData
  }

  return bedroomTypes.length > 3
    ? getMergeHomeData()
    : bedroomTypes.map((bedroom, index) => {
        return {
          title: bedroom == 0 ? 'Studio' : getBedroomTitle(bedroom, index),
          data: bedroomObj[bedroom] || [],
        }
      })
}

export function transformNumberToRooms(number?: string | number) {
  const isWholeNumber = Number(number) % 1 === 0
  const roundedNumber = isWholeNumber ? Number(number).toFixed() : Number(number).toString()
  return roundedNumber
}

export function transformToBedroomText(bedrooms: number | string) {
  return bedrooms === 0 ? 'Studio' : `${transformNumberToRooms(bedrooms)} Bed`
}

export function formatMoney(amount?: number | string, round?: boolean) {
  if (!amount) return

  const options = {
    style: 'currency' as const,
    currency: 'USD',
    maximumFractionDigits: round ? 0 : 2,
    minimumFractionDigits: round ? 0 : 2,
  }
  const formatter = new Intl.NumberFormat('en-US', options)

  // only show a whole number
  return formatter.format(Number(amount))
}

export function transformHomes(availableHomes: AvailableHome[], bookablePerson: WorkspaceTab): RecommendedHomeRow[] {
  return availableHomes.map((home) => {
    const pricingFields = getPricingFields(home)
    return {
      ...home,
      ...pricingFields,
      bookablePersonType: bookablePerson.bookablePersonType,
      userId: bookablePerson.userId ? bookablePerson.userId : undefined,
      bookablePersonId: bookablePerson.bookablePersonId,
      favorite: false,
      pinned: false,
      potentialBookingId: null,
    }
  })
}
